import { EmptyColumnGenerator, MarkdownGenerator, SelectGenerator, TextGenerator } from "../formConstantGenerator";
import validator from "../validator";


export const PLAN_TYPES = [
    { label: 'Monthly (30 days)', value: 'Monthly' },
    { label: 'Quaterly (90 days)', value: 'Quaterly' },
    { label: 'Annually (365 days)', value: 'Annually' }
]

export const PLAN_UNIT = [
    { label: '₹ - INR', value: 'INR' },
    // { label: '৳ - TK ', value: 'BDT' },
    // { label: '$ - USD', value: 'USD' },
    // { label: '£ - GBP', value: 'GBP' },
    // { label: 'A$ - AUD', value: 'AUD' },
    // { label: 'C$ - CAD', value: 'CAD' },
    // { label: 'د.إ - AED', value: 'AED' },
    // { label: 'S$ - SGD', value: 'SGD' },
]

const masterDataFormConstant = {
    forRoles: (permissionOptions = [], readOnly = false) => {
        return [
            new TextGenerator('name', 'Enter Role Name', readOnly, {
                required: validator.isRequired('Role Name').required
            }, 4, 'text'),
            new SelectGenerator('permission', 'Choose Permissions', permissionOptions, readOnly, {
                // required: validator.isRequired('Choose Permissions').required
            }, 8, { multiple: true })
        ]
    },
    forPlans: (readOnly = false) => {
        return [
            new TextGenerator('name', 'Offer Name', readOnly, {
                required: validator.isRequired('Offer Name').required
            }, 4, 'text'),
            new TextGenerator('offer_desc', 'Offer Description', readOnly, {
            }, 4, 'text'),
            new TextGenerator('duration', 'Plan duration (in days)', readOnly, {
                required: validator.isRequired('Duration').required
            }, 4, 'number'),
            new TextGenerator('identifier', 'Hoichoi Plan Identifier', readOnly, {
                required: validator.isRequired('Hoichoi Plan Identifier').required,
                pattern: validator.noSpaceAllowed
            }, 4, 'text'),
            new TextGenerator('offer_identifier', 'Offer Identifier', readOnly, {
                required: validator.isRequired('Offer Identifier').required,
                pattern: validator.noSpaceAllowed
            }, 4, 'text'),
            new SelectGenerator('unit', 'Unit', PLAN_UNIT, readOnly, {
                required: validator.isRequired('Unit').required
            }, 4),
            new TextGenerator('price', 'Amount', readOnly, {
                required: validator.isRequired('Amount').required,
                pattern: validator.onlyNumeric
            }, 4, 'number'),
            new TextGenerator('discount', 'Discount(%)', readOnly, {
            }, 4, 'number'),
            new TextGenerator('offer_brand_name', 'Offer Brand Name', readOnly, {
                required: validator.isRequired('Offer Brand Name').required,
            }, 4, 'text'),
            new TextGenerator('subtitle', 'Subtitle', readOnly, {
            }, 4, 'text'),
            new TextGenerator('card_footer', 'Card Footer', readOnly, {
            }, 4, 'text'),
            new TextGenerator('data', 'Data/Remarks', readOnly, {}, 4, 'text'),
            new TextGenerator('priority', 'Priority', readOnly, {}, 4, 'number'),
            new TextGenerator('bg_url', 'Background Url', readOnly, {}, 4, 'url'),
            new TextGenerator('logo_url', 'Logo Url', readOnly, {}, 4, 'url'),
            new TextGenerator('tag_url', 'Tag Url', readOnly, {}, 4, 'url'),
            new TextGenerator('expire_at', 'Offer Expiry Date', readOnly, {}, 4, 'date'),
            new TextGenerator('defaultOfferCode', 'Default Offer Code', readOnly, {}, 4, 'text'),
            new TextGenerator('tnc_heading', 'Hoichoi Terms & Condition (heading)', readOnly, {}, 4, 'text'),
            new EmptyColumnGenerator(8),
            new MarkdownGenerator('terms_condition', 'Hoichoi Terms & Condition (content)', readOnly, {}, 12),
            new TextGenerator('offer_tnc_heading', 'Brand Offer terms & condition (heading)', readOnly, {}, 4, 'text'),
            new EmptyColumnGenerator(8),
            new MarkdownGenerator('offer_terms_condition', 'Brand Offer terms & condition (content)', readOnly, {}, 12),
        ]
    },
    forBanners: (readOnly = false) => {
        return [
            new TextGenerator('name', 'Banner Name', readOnly, {
                required: validator.isRequired('Banner Name').required
            }, 4, 'text'),
            new TextGenerator('web_banner', 'Web Banner Url', readOnly, {
                required: validator.isRequired('Web Banner Url').required
            }, 4, 'url'),
            new TextGenerator('mobile_banner', 'Mobile Banner Url', readOnly, {
                required: validator.isRequired('Mobile Banner Url').required
            }, 4, 'url'),
            new TextGenerator('priority', 'Priority', readOnly, {
            }, 4, 'number'),
        ]
    }
}

export default masterDataFormConstant;